import React from 'react'
import PropTypes from 'prop-types'
import { SkeletonTile } from './SkeletonTile'
import times from 'lodash/times'

import './style.css.scss'

const SkeletonTiles = ({ numTiles = 1 }) => (
  <div className="skeltons-container">
    { times(numTiles, i => <SkeletonTile key={i} />) }
  </div>
)

SkeletonTiles.propTypes = {
  numTiles: PropTypes.number
}

export default SkeletonTiles
